// extracted by mini-css-extract-plugin
export default {"800":"(min-width: 800px)","1200":"(min-width: 1200px)","root":"pMY75NpBkkHMgCqb8zdD","player":"ZuXyZTBacin8bYCxZWjX","title":"UA5p5WTcwVmlOetEI6Nb","video":"uevcWIQ2IbcWO4Win4WF"};